import { Link } from "react-router-dom";
import { useCompany } from "../../hooks/useCompany";
import { HomeOutlined, CloudDownloadOutlined, CloudUploadOutlined, EditFilled, DeleteOutlined, PlusOutlined, AppstoreAddOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { Button, DatePicker, Form, Input, Modal, Select, TableProps, Typography, ConfigProvider, PopconfirmProps } from 'antd';
import ptBR from 'antd/locale/pt_BR';
import { Table } from "antd";
import './styles.css';
import { macroStepsModel } from "../../models/macroStepsModel";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import TextArea from "antd/es/input/TextArea";
import useLoading from "../../hooks/useLoading";
import { api } from "../../services/axios";
import { toast } from "react-toastify";
import { message, Popconfirm } from 'antd';
import React from 'react';
import daysjs from 'dayjs';
import { SetFileName } from "../../utils/SetFileName";
import useModal from "../../hooks/useModal";
import { UploadModal } from "../../components/Shared/UploadModal";
import { IoCodeSlash } from "react-icons/io5";
import { IResponseProps } from "../../interfaces/IResponseProps";


interface MacroSteps {
    id?: string,
    projectName: string,
    macroStep: string,
    startDate: string | null,
    endDate: string | null,
    description: string
}
interface OptionsProps {
    value: string;
    label: string;
    disabled: boolean;
}

export function MacroSteps() {
    const [formCreate] = Form.useForm();
    const [formEdit] = Form.useForm()
    const Text = Typography;
    const { toggleLoading, loading } = useLoading();
    const { company } = useCompany();
    const [isShowing, setIsShowing] = useState<boolean>(false);
    const [isShowingEdit, setIsShowingEdit] = useState<boolean>(false);
    const { isShowing: isShowingExcelModal, toggle: toggleExcelModal } = useModal();
    const [macroSteps, setMacroSteps] = useState<macroStepsModel[]>([])
    const [total, setTotal] = useState<number>(0);
    const [take, setTake] = useState<number>(7);
    const [page, setPage] = useState<number>(1);
    const { Option } = Select;
    const [itemToDelete, setItemToDelete] = useState<string>("");
    const [startDate, setStartDate] = useState<string>()
    const [endDate, setEndDate] = useState<string>()
    const [fileMacroSteps, setFile] = useState<Blob>();

    const [projectsNames, setProjectsNames] = useState<OptionsProps[]>([]);
    const [projectNameSelected, setProjectNameSelected] = useState<string | null>(null)


    const { handleSubmit, setValue } = useForm<MacroSteps>({});


    const filtersProjectName: { text: string; value: string; }[] = [];
    const filtersMacroSteps: { text: string; value: string; }[] = [];
    const filtersDescription: { text: string; value: string; }[] = [];
    const filtersStartDate: { text: string; value: string; }[] = [];
    const filtersEndDate: { text: string; value: string; }[] = [];

    const formatDate = (dateString: Date) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('pt-BR');
    };
    function handleShowSizeChange(page: number, size: number) {
        setPage(page)
        setTake(size)
    }

    macroSteps.forEach(item => {
        if (!filtersProjectName.some(filter => filter.value === item.projectName)) {
            filtersProjectName.push({
                text: item.projectName,
                value: item.projectName,
            });
        }
        if (!filtersMacroSteps.some(filter => filter.value === item.macroSteps)) {
            filtersMacroSteps.push({
                text: item.macroSteps,
                value: item.macroSteps,
            });
        }
        if (!filtersDescription.some(filter => filter.value === item.description)) {
            filtersDescription.push({
                text: item.description,
                value: item.description,
            });
        }

        const startDateFormated = formatDate(item.startDate);
        const endDateFormated = formatDate(item.endDate);

        if (!filtersStartDate.some(filter => filter.value === startDateFormated)) {
            filtersStartDate.push({
                text: startDateFormated,
                value: startDateFormated,
            });
        }
        if (!filtersEndDate.some(filter => filter.value === endDateFormated)) {
            filtersEndDate.push({
                text: endDateFormated,
                value: endDateFormated,
            });
        }
    });

    const ProjectsMaterialsColumns: TableProps<macroStepsModel>['columns'] = [
        {
            title: "Nome do Projeto",
            key: 'projectName',
            dataIndex: 'projectName',
            filters: filtersProjectName,
            onFilter: (value, record) => record.projectName === value,
            sorter: (a, b) => a.projectName.localeCompare(b.projectName),
            sortDirections: ['ascend', 'descend'],
        },
        {
            title: 'Macro Etapas',
            dataIndex: 'macroSteps',
            key: 'macroSteps',
            filters: filtersMacroSteps,
            onFilter: (value, record) => record.macroSteps.includes(value as string),
            sorter: (a, b) => a.macroSteps.localeCompare(b.macroSteps),
            sortDirections: ['ascend', 'descend'],
        },
        {
            title: 'Descrição',
            dataIndex: 'description',
            key: 'description',
            filters: filtersDescription,
            onFilter: (value, record) => record.description.includes(value as string),
            sorter: (a, b) => a.description.localeCompare(b.description),
            sortDirections: ['ascend', 'descend'],
        },
        {
            title: 'Data de Inicio',
            dataIndex: 'startDate',
            key: 'startDate',
            render: (value) => (
                <div>
                    <p>
                        {formatDate(value)}
                    </p>
                </div>
            ),
            filters: filtersStartDate,
            onFilter: (value, record) => {
                const recordDate = new Date(record.startDate);
                const filterDate = new Date(value as string);
                return recordDate.toDateString() === filterDate.toDateString();
            },
            sorter: (a, b) => new Date(a.startDate).getTime() - new Date(b.startDate).getTime(),
            sortDirections: ['ascend', 'descend'],
        },
        {
            title: 'Data de Fim',
            dataIndex: 'endDate',
            key: 'endDate',
            render: (value) => (
                <div>
                    <p>
                        {formatDate(value)}
                    </p>
                </div>
            ),
            filters: filtersEndDate,
            onFilter: (value, record) => {
                const recordDate = new Date(record.endDate);
                const filterDate = new Date(value as string);
                return recordDate.toDateString() === filterDate.toDateString();
            },
            sorter: (a, b) => new Date(a.endDate).getTime() - new Date(b.endDate).getTime(),
            sortDirections: ['ascend', 'descend'],
        },
        {
            title: 'Ações',
            dataIndex: 'id',
            key: 'id',
            render: (value) => (
                <div>
                    <Button type="text" size="small" style={{ height: "24px", width: "24px" }} onClick={() => { GetMacroStepForEdit(value); setIsShowingEdit(true); }} ><EditFilled className="blue" /></Button>
                    <Popconfirm
                        title="Deletar Macro Etapa"
                        description="Tem certeza que deseja deletar?"
                        onConfirm={() => DeleteMacroSteps()}
                        okText="Sim"
                        cancelText="Não"
                        okButtonProps={{ className: 'btn-delete' }}
                        icon={<ExclamationCircleOutlined style={{ color: 'red' }} />}
                    >
                        <Button type="text" size="small" style={{ height: "24px", width: "24px" }} onClick={() => { setItemToDelete(value) }}><DeleteOutlined className="color-red" /></Button>
                    </Popconfirm>

                </div >
            )
        }
    ];

    async function handleDownloadExceMacroSteps() {
        try {
            toggleLoading(true);

            await api.get(`MacroSteps/DownloadExcel/${company.serviceId}`, {
                responseType: 'blob'
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', SetFileName(company.title, company.year.toString(), "Macro Etapas", "xlsx"));
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            });
        }
        catch (error: any) {
            toast.error(error);
        }
        finally {
            toggleLoading(false);
        }
    }
    async function handleUploadMacroSteps() {
        try {
            debugger;
            toggleLoading(true);
            toggleExcelModal();

            var formData = new FormData();

            if (fileMacroSteps != undefined) {
                formData.append('file', fileMacroSteps);
            }
            formData.append('serviceId', company.serviceId);


            var result = await api.post(`/MacroSteps/UploadExcel`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            var response = result.data;
            if (response.statusCode == 200) {
                toast.success("Upload realizado com sucesso !")
                getAllMacroStepsPagination();
            }
        } catch (err: any) {
            toast.error(err);
            toggleLoading(false);
        } finally {
            toggleLoading(false);

        }
    }

    async function CreateMacroSteps(data: any) {
        try {
            toggleLoading(true);
            debugger;
            var createMacroStepsObj = data;
            createMacroStepsObj.serviceId = company.serviceId;
            await api.post('MacroSteps/CreateMacroSteps', createMacroStepsObj).then((resp) => {
                debugger;
                var response = resp.data;
                if (response.statusCode == 200) {
                    toast.success("Macro Etapa cadastrada com sucesso!");
                    window.location.reload();
                }
            });
        } catch (error: any) {
            toast.error(error);
            toggleLoading(false);
        } finally {
            toggleLoading(false);
        }
    }

    const EditMacroStep = async (data: MacroSteps) => {
        try {
            toggleLoading(true);
            debugger;
            await api.post('MacroSteps/EditMacroSteps', data).then((resp) => {
                debugger;
                var response = resp.data;
                if (response.statusCode == 200) {
                    window.location.reload();
                    toast.success("Macro Etapa cadastrada com sucesso!");
                }
            });
        } catch (error: any) {
            toast.error(error);
            toggleLoading(false);
        } finally {
            toggleLoading(false);
        }
    }

    async function DeleteMacroSteps() {

        try {
            const macroSteps = { MacroStepsId: itemToDelete };
            await api.delete("MacroSteps/DeleteItem", { data: macroSteps }).then((resp) => {
                const response = resp.data;
                if (response.statusCode === 200) {
                    toast.success("Macro Etapa deletado com sucesso !!");
                }
            });
        } catch (error: any) {
            toast.error(error);
        } finally {
            setTimeout(() => {
                window.location.reload();
            }, 1500)

            toggleLoading(false);
        }
    }

    async function GetMacroStepForEdit(id: string) {
        try {
            toggleLoading(true)
            await api.get(`MacroSteps/GetAllById/${id}`,).then((resp) => {
                if (resp.status === 200) {
                    debugger;
                    formEdit.setFieldsValue({ projectname: resp.data.projectName, id: id, description: resp.data.description, macroStep: resp.data.macroSteps, startDate: resp.data.startDate, endDate: resp.data.endDate })
                    setStartDate(resp.data.startDate);
                    setEndDate(resp.data.endDate)
                }
            })
        } catch (error: any) {

        } finally {
            toggleLoading(false)
        }
    }

    async function getAllSelects() {
        toggleLoading(true);
        try {
            var serviceId = company.serviceId;
            await api.get(`MacroSteps/GetAllSelects/${serviceId}`,).then((response) => {
                if (response.status === 200) {
                    setProjectsNames(response.data);
                }
            });
        }
        catch (error: any) {
            toast.error(error);
        }
        finally {
            toggleLoading(false);
        }
    }

    async function getAllMacroStepsPagination() {
        toggleLoading(true);
        try {
            var serviceId = company.serviceId;
            await api.get(`MacroSteps/GetAllMacroStepsPagination/${serviceId}/${page}/${take}`,).then((resp) => {
                if (resp.status === 200) {
                    debugger;
                    const response = resp.data;
                    setMacroSteps(response.items);
                    setTotal(response.total);
                }
            });

        } catch (error: any) {
            toast.error(error)
        } finally {
            toggleLoading(false)
        }
    }
    useEffect(() => {
        getAllSelects();
        getAllMacroStepsPagination();
    }, [])

    useEffect(() => {
        getAllMacroStepsPagination();
    }, [page, take]);

    return (
        <>
            <div className='card '>
                <div className='card-header'>
                    <div className='breadCrumb'>

                        <Link to={`/${company.serviceId}/home`} className='breadCrumb-home d-flex align-items-center'>
                            <HomeOutlined className="breadCrumb-item-actual  mx-1" />
                            <span className='breadCrumb-item mx-1'>Homepage</span>
                        </Link>

                        <span className='breadCrumb-separator'>{' / '}</span>
                        <span className='breadCrumb-item mx-1'>Identificação Técnica</span>
                        <span className='breadCrumb-separator'>{' / '}</span>
                        <span className='breadCrumb-item mx-1'>Macro Etapas</span>
                    </div>
                </div>

                <div className="container-buttons-excel">
                    <div className="div-button">
                        <Button size="large" iconPosition="start" onClick={() => handleDownloadExceMacroSteps()} icon={<CloudDownloadOutlined />}> Download Modelo</Button>
                    </div>
                    <div className="div-button">
                        <Button size="large" iconPosition="start" onClick={() => toggleExcelModal()} icon={<CloudUploadOutlined />}>Upload Modelo</Button>
                    </div>
                    <div className="div-button">
                        <Button size="large" type="primary" className="button-blue" iconPosition="start" icon={<PlusOutlined />} onClick={() => setIsShowing(true)}>Inserir Macro Etapa</Button>
                    </div>
                </div>
                <Table
                    loading={loading}
                    rowKey="id"
                    pagination={{
                        total: total,
                        showSizeChanger: true,
                        showTotal: (total) => <Text>Total {total} items</Text>,
                        pageSize: take,
                        current: page,
                        onShowSizeChange: (page, size) => handleShowSizeChange(page, size),
                        onChange: (page, size) => {
                            handleShowSizeChange(page, size);
                        },

                    }}
                    columns={ProjectsMaterialsColumns}
                    dataSource={macroSteps}
                />

                <Modal
                    title={
                        <>
                            <div className="d-flex justify-content-start align-items-start">
                                <AppstoreAddOutlined className="icon-size-create" /><p className="mx-3 font-title">Adicionar Macro Etapa</p>
                            </div>
                        </>
                    }
                    loading={loading}
                    open={isShowing}
                    width={960}
                    height={419}
                    footer={
                        <>
                        </>
                    }
                    onCancel={() => setIsShowing(false)}>

                    <Form onFinish={handleSubmit(CreateMacroSteps)} layout="vertical" form={formCreate} requiredMark={false}>
                        <div className="d-flex justify-content-between align-items-center gap-3">
                            <Form.Item
                                className="w-50"
                                name={'projectname'}
                                initialValue={projectNameSelected}
                                label={
                                    <div className="d-flex justify-content-center align-items-center"><span className="span-label">Nome do Produto: <b className="color-red">*</b></span></div>
                                }
                                rules={[{ required: true, message: 'Por favor, selecione uma opção!' }]}>

                                <Select
                                    placeholder='Selecione Uma opção abaixo'
                                    size='large'
                                    onChange={(value) => {
                                        const selectedOption = projectsNames.find(item => item.value === value);
                                        setProjectNameSelected(selectedOption ? selectedOption.label : "");
                                        setValue("projectName", value);
                                    }}

                                >
                                    {
                                        projectsNames != undefined ?
                                            projectsNames.sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase())).map((item) => (
                                                <Option key={item.value} value={item.value}>
                                                    {item.label}
                                                </Option>
                                            ))
                                            :
                                            <></>
                                    }

                                </Select>
                            </Form.Item>

                            <Form.Item
                                className="w-50"
                                name={'macroStep'}
                                label={
                                    <div className="d-flex justify-content-center align-items-center"><span className="span-label">Macro Etapa: <b className="color-red">*</b></span></div>
                                }
                                rules={[{ required: true, message: 'Campo Obrigatório!' }]}>
                                <Input
                                    size='large'
                                    className='form-control'
                                    placeholder="000000"
                                    onChange={(e) => setValue("macroStep", e.target.value)}
                                />
                            </Form.Item>
                        </div>

                        <div className="d-flex justify-content-between align-items-center gap-3">
                            <Form.Item
                                className="w-50"
                                label={
                                    <div className="d-flex justify-content-center align-items-center"><span className="span-label">Data de Início:</span></div>
                                }>
                                <ConfigProvider locale={ptBR}>
                                    <DatePicker
                                        size='large'
                                        className='form-control '
                                        placeholder="Selecione uma data"
                                        format="DD/MM/YYYY"
                                        onChange={(date) => {
                                            if (date) {
                                                const jsDate = date.toDate();
                                                const day = String(jsDate.getDate()).padStart(2, '0');
                                                const month = String(jsDate.getMonth() + 1).padStart(2, '0');
                                                const year = jsDate.getFullYear();
                                                const formattedDate = `${day}/${month}/${year}`;
                                                setValue("startDate", formattedDate);
                                            } else {
                                                setValue("startDate", null);
                                            }
                                        }}
                                    />
                                </ConfigProvider>
                            </Form.Item>

                            <Form.Item
                                className="w-50"
                                label={
                                    <div className="d-flex justify-content-center align-items-center"><span className="span-label">Data de Fim:</span></div>
                                }>
                                <ConfigProvider locale={ptBR}>
                                    <DatePicker
                                        format={"DD/MM/YYYY"}
                                        size='large'
                                        className='form-control'
                                        placeholder="Selecione uma data"
                                        onChange={(date) => {
                                            if (date) {
                                                const jsDate = date.toDate();
                                                const day = String(jsDate.getDate()).padStart(2, '0');
                                                const month = String(jsDate.getMonth() + 1).padStart(2, '0');
                                                const year = jsDate.getFullYear();
                                                const formattedDate = `${day}/${month}/${year}`;
                                                setValue("endDate", formattedDate);
                                            } else {
                                                setValue("endDate", null);
                                            }
                                        }
                                        }

                                    />
                                </ConfigProvider>
                            </Form.Item>
                        </div>

                        <div className="d-flex justify-content-between align-items-center">
                            <Form.Item className="w-100"
                                label={
                                    <div className="d-flex justify-content-center align-items-center"><span className="span-label">Descrição: <b className="color-red">*</b></span></div>
                                }
                                name={'description'}
                                rules={[{ required: true, message: 'Campo Obrigatório!' }]}>
                                <TextArea
                                    size='large'
                                    rows={4}
                                    className='form-control'
                                    onChange={(e) => setValue("description", e.target.value)}

                                    placeholder="Digite Aqui..."
                                />
                            </Form.Item>
                        </div>

                        <div className="d-flex gap-3 pt-4" style={{ marginBottom: '-25px' }}>
                            <Button size="large" className="w-50" onClick={() => setIsShowing(false)}>
                                Cancelar
                            </Button>

                            <Button size="large" className="w-50 button-blue" type="primary" htmlType="submit">
                                <span>Cadastrar</span>
                            </Button>
                        </div>

                    </Form>
                </Modal>

                <Modal
                    title={
                        <>
                            <div className="d-flex justify-content-start align-items-start">
                                <AppstoreAddOutlined className="icon-size-create" /><p className="mx-3 font-title">Editar Macro Etapa</p>
                            </div>
                        </>
                    }
                    loading={loading}
                    open={isShowingEdit}
                    width={960}
                    height={419}
                    footer={
                        <>
                        </>
                    }
                    onCancel={() => setIsShowingEdit(false)}>

                    <Form onFinish={EditMacroStep} layout="vertical" form={formEdit} requiredMark={false}>
                        <div className="d-flex justify-content-between align-items-center gap-3">
                            <Form.Item
                                className="w-50"
                                name={'projectname'}
                                label={
                                    <div className="d-flex justify-content-center align-items-center"><span className="span-label">Nome do Produto: <b className="color-red">*</b></span></div>
                                }
                                rules={[{ required: true, message: 'Por favor, selecione uma opção!' }]}>

                                <Select
                                    placeholder='Selecione Uma opção abaixo'
                                    size='large'
                                    onChange={(value) => {
                                        const selectedOption = projectsNames.find(item => item.value === value);
                                        setValue("projectName", value);
                                    }}

                                >
                                    {
                                        projectsNames != undefined ?
                                            projectsNames.sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase())).map((item) => (
                                                <Option key={item.value} value={item.value}>
                                                    {item.label}
                                                </Option>
                                            ))
                                            :
                                            <></>
                                    }

                                </Select>
                            </Form.Item>

                            <Form.Item
                                className="w-50"
                                name={'macroStep'}
                                label={
                                    <div className="d-flex justify-content-center align-items-center"><span className="span-label">Macro Etapa: <b className="color-red">*</b></span></div>
                                }
                                rules={[{ required: true, message: 'Campo Obrigatório!' }]}>
                                <Input
                                    size='large'
                                    className='form-control'
                                    placeholder="000000"
                                    onChange={(e) => setValue("macroStep", e.target.value)}
                                />
                            </Form.Item>
                        </div>

                        <div className="d-flex justify-content-between align-items-center gap-3">
                            <Form.Item
                                className="w-50"
                                name={'startDate'}
                                label={
                                    <div className="d-flex justify-content-center align-items-center"><span className="span-label">Data de Início:</span></div>
                                }>
                                <ConfigProvider locale={ptBR}>
                                    <DatePicker
                                        size='large'
                                        className='form-control '
                                        placeholder="Selecione uma data"
                                        format="DD/MM/YYYY"
                                        defaultValue={daysjs(startDate)}
                                        onChange={(date) => {
                                            if (date) {
                                                const jsDate = date.toDate();
                                                const day = String(jsDate.getDate()).padStart(2, '0');
                                                const month = String(jsDate.getMonth() + 1).padStart(2, '0');
                                                const year = jsDate.getFullYear();
                                                const formattedDate = `${day}/${month}/${year}`;
                                                setValue("startDate", formattedDate);
                                            } else {
                                                setValue("startDate", null);
                                            }
                                        }}
                                    />
                                </ConfigProvider>
                            </Form.Item>

                            <Form.Item
                                className="w-50"
                                name={'endDate'}
                                label={
                                    <div className="d-flex justify-content-center align-items-center"><span className="span-label">Data de Fim:</span></div>
                                }>
                                <ConfigProvider locale={ptBR}>
                                    <DatePicker
                                        format={"DD/MM/YYYY"}
                                        size='large'
                                        className='form-control'
                                        defaultValue={daysjs(endDate)}
                                        placeholder="Selecione uma data"
                                        onChange={(date) => {
                                            if (date) {
                                                const jsDate = date.toDate();
                                                const day = String(jsDate.getDate()).padStart(2, '0');
                                                const month = String(jsDate.getMonth() + 1).padStart(2, '0');
                                                const year = jsDate.getFullYear();
                                                const formattedDate = `${day}/${month}/${year}`;
                                                setValue("endDate", formattedDate);
                                            } else {
                                                setValue("endDate", null);
                                            }
                                        }
                                        }

                                    />
                                </ConfigProvider>
                            </Form.Item>
                        </div>

                        <div className="d-flex justify-content-between align-items-center">
                            <Form.Item className="w-100"
                                label={
                                    <div className="d-flex justify-content-center align-items-center"><span className="span-label">Descrição: <b className="color-red">*</b></span></div>
                                }
                                name={'description'}
                                rules={[{ required: true, message: 'Campo Obrigatório!' }]}>
                                <TextArea
                                    size='large'
                                    rows={4}
                                    className='form-control'
                                    onChange={(e) => setValue("description", e.target.value)}
                                    placeholder="Digite Aqui..."
                                />
                            </Form.Item>

                        </div>
                        <div className="d-none">
                            <Form.Item className="w-100"
                                name={'id'}>
                            </Form.Item>
                        </div>

                        <div className="d-flex gap-3 pt-4" style={{ marginBottom: '-25px' }}>
                            <Button size="large" className="w-50" onClick={() => setIsShowing(false)}>
                                Cancelar
                            </Button>

                            <Button size="large" className="w-50 button-blue" type="primary" htmlType="submit">
                                <span>Cadastrar</span>
                            </Button>
                        </div>

                    </Form>
                </Modal>

                {isShowingExcelModal &&
                    <UploadModal
                        action={handleUploadMacroSteps}
                        isShowing={isShowingExcelModal}
                        toggle={toggleExcelModal}
                        setFile={setFile}
                    />
                }
            </div>


        </>
    )
}